export default {
    locale: 'en',
    global: {
        appName: 'Trisbee Pokladna',
        ok: 'Ok',
        offline: 'offline',
        back: 'Back',
        delete: 'Delete',
        save: 'Save',
        logout: 'Sign out',
        print: 'Print',
        yes: 'Yes',
        no: 'No',
        reload: 'Reload'
    },
    login: {
        changeOrganization: 'Switch organisation',
        language: 'Change language',
        login: 'Email',
        password: 'Password',
        loginBtn: 'Sign in'
    },
    chooseBar: {
        noBranch: {
            title: 'No bar',
            text: 'You need to create new bar, add a cash register and fill some items into the menu.'
        },
        selectBranch: {
            title: 'Select bar'
        }
    },
    deviceName: {
        title: 'Select name for the device',
        deviceName: 'Device name'
    },
    chooseOffer: {
        title: 'Select menu'
    },
    browser: {
        line1: 'Unfortunately your browser is old or unsupported.',
        line2: 'Please download one of the following:'
    },
    openReport: {
        title: 'Day opening',
        text1: 'The bar',
        text2: 'does not have any bar report opened.',
        text3: 'Do you want to open bar report now?',
        open: 'Open bar report',
        alreadyOpen: 'Report already opened.'
    },
    homepage: {
        controls: {
            table: 'Account',
            issue: 'Sale',
            quickSale: 'Quick sale',
            toBill: 'Put on debt list',
            pay: 'Pay'
        },
        receipt: {
            sum: 'Total',
            table: 'account'
        }
    },
    tables: {
        newTable: 'New account',
        toCashbox: 'To cash register',
        layout: {
            select: 'Select table layout',
            noLayout: 'No layout'
        },
        newPopup: {
            title: 'Account title',
            nameNotUnique: 'The title is not unique'
        }
    },
    divideTable: {
        payAll: 'Pay all',
        removeAll: 'Delete all',
        toBill: 'To new bill',
        pay: 'Pay'
    },
    payment: {
        sale: 'Discount',
        paid: 'Paid',
        afterSale: 'After discount',
        toPayment: 'To be paid',
        return: 'Return',
        sell: 'Sell'
    },
    menu: {
        waitingOrders: 'Count of unsubmitted offline bills:',
        toTables: 'To tables',
        toCashbox: 'To cash register',
        message: {
            reportClosed1: 'The bar report is already closed, last ',
            reportClosed2: 'sales are saved out of the report.',
            deviceOffline: 'The device is offline.',
            unableCloseReport: 'Cannot close the bar report.',
            notSentBills: 'Count of unsubmitted bills:',
            billSendLater: 'These bills will be sent on next logon.',
            tablesNotPayed: 'Not all accounts are paid'
        },
        issuedReceipts: 'Bills issued',
        dailyReport: 'Daily report',
        credits: 'Debt list',
        favourites: 'Favourite items',
        settings: 'Settings',
        lock: 'Lock / Switch user',
        offlineMode: '(Offline mode)',
        shifts: 'Shifts',
        payouts: 'Cash payout',
        cashboxState: 'Cash status'
    },
    issuedReceipts: {
        title: 'Bills issued',
        time: 'Time',
        table: 'Account',
        items: 'Items',
        sum: 'amount',
        cashbox: 'Cashbox',
        storno: 'Cancel'
    },
    credits: {
        title: 'Debt list',
        paySelected: 'Pay selected',
        payAll: 'Pay all',
        date: 'Put on tab',
        table: 'Account',
        entered: 'Entered by',
        debt: 'Debt',
        pay: 'Pay',
        print: 'Print'
    },
    favourites: {
        title: 'Favourite items',
        addShortcut: 'Add selection',
        frequentlyUsed: 'Frequently used items'
    },
    settings: {
        title: 'Settings',
        lockTime: 'Lock time',
        tabs: {
            sell: 'Sell',
            system: 'System',
            print: 'Print'
        },
        disable: 'Disable',
        selectOffer: 'Select menu',
        on: 'On',
        off: 'Off',
        allow: 'Enable',
        deny: 'disable',
        printBill: {
            title: 'Print the bill while selling',
            subtitle: 'Automatically print the bill after payment'
        },
        localstorage: {
            send: 'Send',
            title: 'Send system information',
            subtitle: 'Use only when instructed to do so.'
        },
        deviceName: {
            title: 'Device name',
            change: 'Change',
            keyboardName: 'Device name (at least three characters)',
            error: 'Input at least three characters'
        },
        print: {
            bt: 'Enter the name of the paired Bluetooth device',
            ipOrHost: 'Please enter IP or hostname, eventually port (default port 9100) (e.g. 192.168.2.4 or 10.0.2.3:9100 or posprinter:9100)',
            device: 'Device (e.g. /dev/ttyS0 or COM1)',
            lineLength: 'Line width - number of characters',
            test: 'Test ESC/POS'
        },
        offer: {
            title: 'Menu',
            select: 'Select menu'
        },
        fullscreen: {
            title: 'Use fullscreen window'
        },
        homepage: {
            title: 'Main screen',
            subtitle: 'Where the order begins to be put in',
            goods: 'Goods',
            tables: 'Accounts'
        },
        kitchenPrint: {
            title: 'Print order at the time of adding it onto account or selling',
            subtitle: 'Only goods marked as "order" is being printed out',
            test: 'Test ESC/POS'
        },
        kitchenItemStyle: {
          title: 'Print goods in order separately',
          subtitle: 'Lists goods in rows according to quantity'
        },
        pin: {
            title: 'Sign in with PIN',
            subtitle: 'PIN signon enabled up to 24 hours after last signout'
        },
        cursor: {
            title: 'Hide cursor',
            subtitle: 'For usage with touch screens'
        },
        paymentInput: {
            title: 'Select on payment',
            sale: 'Discount %',
            saleCurrency: 'Discount CZK',
            paid: 'paid'
        },
        autoLock: {
            title: 'Automatic screen locking'
        },
        printType: {
            title: 'Default print type',
            kitchenTitle: 'Kitchen receipt print type',
            subtitle: 'Used for bills and reports',
            change: 'Change',
            charOnLine: 'characters per line',

            off: 'Off',
            default: 'Default printer',
            defaultSilent:  'Default printer (without dialog confirmation)',
            escposUsb: 'ESC/POS USB',
            escposSerial: 'ESC/POS Serial port',
            escposNet: 'ESC/POS Network printer',
            escposBt: 'ESC/POS Bluetooth printer'
        },
        printTypeOrder: {
            title: 'Order print type',
            subtitle: 'Only goods marked as "order" is being printed out',
            charOnLine: 'characters per line',
            change: 'Change'
        },
        silentPrint: {
            title: 'Silent print',
            subtitle: 'Background bill printing (without popup window with printer selection)'
        },
        language: {
            title: 'Language'
        }
    },
    pin: {
        changeOrg: 'Change organisation',
        pin: 'PIN',
        passwordLogin: 'Password sign in'
    },
    domain: {
        orgCode: 'Organisation code',
        codeNotExists: 'Organisation code does not exist.',
        continue: 'Continue',
        serverUnavailable: 'Server is currently not available. Please try again later.',
        migrationTroubleshoot: 'Troubleshoot migration'
    },
    migrationTroubleShooter: {
        migrationId: 'Migration ID',
        migrationIdError: 'An exception has occured. Did you input the migration ID correctly?'
    },
    moneyCount: {
        fillPcs: 'Enter pieces',
        sum: 'Total',
        count: 'Count',
        dailyReport: 'Daily report > Cash status',
        cashbox: 'Cash register',
        start: 'Begin',
        end: 'End'
    },
    timepicker: {
        am: 'Forenoon',
        pm: 'Afternoon'
    },
    shifts: {
        barmanSelect: 'Select bartender',
        payFromCashbox: 'Pay from cash register',
        dailyReport: 'Daily report > Shifts',
        add: 'Add',
        barman: 'Bartender',
        rate: 'Rate',
        from: 'from',
        to: 'to',
        salary: 'Wage',
        endShift: 'End shift',
        paid: 'Paid'
    },
    transactions: {
        new: 'New transaction',
        chooseCashbox: 'Choose cash register',
        income: 'Income',
        outcome: 'Outcome',
        transfer: 'Transfer',
        send: 'Send',
        dailyReport: 'Daily report > Payouts',
        add: 'Add',
        time: 'Time',
        paied: 'Paid out/Paid',
        amount: 'Amount',
        created: 'Created by',
        name: 'Title',
        fromCashbox: 'From cash register',
        toCashbox: 'To cash register',
        cashbox: 'Cash registers',
        idNumber: 'Document No.',
        note: 'Note'
    },
    print: {
        order: 'Order',
        bar: 'Bar',
        bill: 'Account',
        debtList: 'Debt list',
        storno: 'CANCEL',
        discount: 'Discount',
        idNumber: 'Reg.ID',
        vatId: 'VAT ID',
        vat: 'VAT',
        reportNotOpen: 'No bar report opened or nothing sold yet.',
        noVat: 'Non-taxable person',
        sale: 'SALE',
        turnover: 'CASH REGISTERS\' TUROVER',
        difference: 'DIFFERECE',
        sales: 'TAKE (incl. accounts)',
        documentId: 'Document no.',
        orderNum: 'Order no.',
        payInCash: 'Cash payments',
        payByCard: 'Card payments',
        normalMode: 'Standard mode',
        offlineMode: 'Offline mode',
        branch: 'Branch',
        onlineBill: 'Online bill',
        thankYou: 'THANK YOU AND SEE YOU SOON AGAIN',
        soldAndPrint: 'sold and printed by Trisbee.com',
        notReceipt: 'This is not a receipt. Please, ask the service for a receipt',
        tableToDate: 'Table state as at'
    },
    closeReport: {
        closeDay: 'Close the daily report',
        reportOpen: 'Bar report is opened, would you like to close it now?',
        cantClose: 'Not possible to close the bar report. Reason:',
        tryAgain: 'Try again to close the bar report and sign off',
        closeAndLogout: 'Close the bar report and sign off',
        onlylogout: 'Sign off only',
        continue: 'Continue',
        closeReport: 'Close bar report'
    }
}



// WEBPACK FOOTER //
// ./src/common/intl/messages/en.js